import React from 'react';
import { GraduationCap } from 'lucide-react';
import { Row, Col, Select, SectionTitle, FormField } from '../../../SharedInputs.jsx';
import { COURSE_OPTIONS, COURSE_OPTIONS_DOMESTIC } from '../../../../constants.js';

export function SectionCampusCourse({ value, onChange, errors = [], dispatch, category }) {
  const updateField = (field, fieldValue) => {
    onChange({ ...value, [field]: fieldValue });
  };

  const toggleCourse = (course) => {
    const currentCourses = value.courses || [];
    if (currentCourses.includes(course)) {
      // Remove course if already selected
      updateField('courses', currentCourses.filter(c => c !== course));
    } else {
      // Add course if not selected
      updateField('courses', [...currentCourses, course]);
    }
  };

  const getFieldError = (fieldName) => {
    return errors.find(error => error.toLowerCase().includes(fieldName.toLowerCase()));
  };

  return (
    <div>
      <SectionTitle icon={GraduationCap} step={2}>
        Campus & Course Selection
      </SectionTitle>

      <Row>
        <Col span={12}>
          <FormField 
            label="Campus" 
            required
            error={getFieldError('campus')}
          >
            <Select
              required
              value={value.campus || ''}
              onChange={(e) => updateField('campus', e.target.value)}
              error={getFieldError('campus')}
            >
              <option value="">Select Campus</option>
              <option value="Canberra Campus">Canberra Campus</option>
              <option value="Melbourne Campus">Melbourne Campus</option>
            </Select>
          </FormField>
        </Col>
      </Row>
      <Row>
        <Col span={12}>
          <FormField 
            label="Courses" 
            required
            error={getFieldError('courses')}
            hint="Select one or more courses you want to study"
          >
            <div>
              {category === 'international' && (
                COURSE_OPTIONS.map((course) => (
                  <label key={course} style={{ display: 'block', marginBottom: 4 }}>
                    <input
                      type="checkbox"
                      checked={(value.courses || []).includes(course)}
                      onChange={() => toggleCourse(course)}
                    />{' '}
                    {course}
                  </label>
                ))
              )}
              {category === 'domestic' && (
                COURSE_OPTIONS_DOMESTIC.map((course) => (
                  <label key={course} style={{ display: 'block', marginBottom: 4 }}>
                    <input
                      type="checkbox"
                      checked={(value.courses || []).includes(course)}
                      onChange={() => toggleCourse(course)}
                    />{' '}
                    {course}
                  </label>
                ))
              )}
            </div>
          </FormField>
        </Col>
      </Row>

      {/* Selected Courses Display */}
      {(value.courses && value.courses.length > 0) && (
        <div style={{
          marginTop: 20,
          padding: 16,
          background: '#f8faff',
          borderRadius: 8,
          border: '1px solid #e0e7ff'
        }}>
          <h4 style={{ margin: '0 0 8px', color: '#374151' }}>Selected Courses:</h4>
          <ul style={{ margin: 0, paddingLeft: 20, color: '#6b7280', fontSize: 14 }}>
            {value.courses.map(course => (
              <li key={course}>{course}</li>
            ))}
          </ul>
          <p style={{ margin: '8px 0 0', color: '#9ca3af', fontSize: 12 }}>
            Campus: {value.campus || 'Not selected'}
          </p>
        </div>
      )}
    </div>
  );
}
